/**
 * Incident Facilities Report Handler
 * Handles: Community Kitchen, Animal Shelter, Flood Relief Camp
 */

import { generateIncidentFacilitiesExcel } from '../exportTableDataIncidentFacilities';

/**
 * Handle Incident Facilities Report Downloads
 * @param {Object} message - Message object containing debug data
 * @param {string} format - Export format ('pdf' or 'excel')
 */
export const handleIncidentFacilitiesDownload = async (message, format) => {
  console.log('🏘️ Incident Facilities Handler Called');
  console.log('- Format:', format);

  // Extract data from message
  const rawData = message.debug?.tool_result?.result?.data;
  const toolName = message.debug?.tool_name;
  const filename = message.debug?.filename;

  console.log('- Tool name:', toolName);
  console.log('- Data records:', rawData?.length || 0);
  console.log('- Filename:', filename);

  // Validate data
  if (!rawData || !Array.isArray(rawData)) {
    console.error('❌ No valid data found');
    alert('No valid data found for this report');
    return;
  }

  if (rawData.length === 0) {
    console.warn('⚠️ Empty data array');
    alert('No records found to export');
    return;
  }

  // Only Excel format is supported for incident facilities
  if (format !== 'excel') {
    console.warn('⚠️ Unsupported format:', format);
    alert('Incident Facilities reports only support Excel format');
    return;
  }

  try {
    await generateIncidentFacilitiesExcel({
      data: rawData,
      toolName: toolName,
      filename: filename
    });
    console.log('✅ Incident Facilities Excel generated successfully');
  } catch (error) {
    console.error('❌ Incident Facilities Excel generation failed:', error);
    console.error('Stack:', error.stack);
    alert(`Excel Generation Error: ${error.message}`);
  }
};

/**
 * Check if tool name is an incident facilities report
 * @param {string} toolName - Tool name from backend
 * @returns {boolean}
 */
export const isIncidentFacilitiesReport = (toolName) => {
  const incidentFacilitiesReports = [
    // ✅ BACKEND TOOL NAMES (All 3 reports)
    'incidentcommunitykitchenreport',
    'incident_community_kitchen_report',
    'incidentfloodreliefcampreport',
    'incident_flood_relief_camp_report',
    'incidentanimalshelterreport',
    'incident_animal_shelter_report',
    
    // Legacy/alternate names
    'community_kitchen',
    'communitykitchen',
    'incident_community_kitchen',
    'incidentcommunitykitchen',
    'animal_shelter',
    'animalshelter',
    'incident_animal_shelter',
    'incidentanimalshelter',
    'flood_relief_camp',
    'floodreliefcamp',
    'incident_flood_relief_camp',
    'incidentfloodreliefcamp'
  ];
  
  return incidentFacilitiesReports.includes(toolName?.toLowerCase());
};
